/* eslint-disable react/prop-types */
import Flag from '@atlaskit/flag';
import SuccessIcon from '@atlaskit/icon/glyph/check-circle';
import { token } from '@atlaskit/tokens';
import { FlagComponentProps } from './FlagTypes';

const OrgOwnedAccountLinkSuccessFlag: React.FC<FlagComponentProps> = ({
  onDismiss,
  linkedEmail,
}) => {
  return (
    <Flag
      icon={
        <SuccessIcon
          label="Success"
          primaryColor={token('color.background.success.bold')}
        />
      }
      appearance="normal"
      onDismissed={onDismiss}
      id={'OrgOwnedAccountLinkSuccessFlag'}
      title={'Account added'}
      description={`We've linked ${linkedEmail} to your account.`}
      actions={[{ content: 'Log in' }]}
    />
  );
};

export default OrgOwnedAccountLinkSuccessFlag;
